// stores
import {writable} from "svelte/store";

/** ModalWindow **/
export const modalComponent = writable(null);
export const dialogTitle = writable('');
export const dialogBody = writable('');
export const linkConverter = writable(true);

/** AllDatabases **/
export const searchTerm = writable('');
export const searchedByLetter = writable(false);
export const showSummary = writable(false);
export const databasesNotFound = writable(false);
export const byPeer = writable(false);
export const clickedLetter = writable('');

/** ByFormat **/
export const selectedFormat = writable('');

/** byClass **/
export const selectedClass = writable('');

/** copy to clipboard **/
export const clipboardStore = writable('');

